export type DeliveryRepresentativeSource = {
  representativeCompany?: string | null;
  representativeFirstName?: string | null;
  representativeLastName?: string | null;
};

export function getDurationParts(durationMinutes: number | null | undefined) {
  const totalMinutes = durationMinutes ?? 0;
  return {
    hours: Math.floor(totalMinutes / 60),
    minutes: totalMinutes % 60,
  };
}

export function getRepresentativeLabel(delivery: DeliveryRepresentativeSource): string {
  const company = delivery.representativeCompany?.trim() ?? "";
  if (company.length > 0) return company;

  const name =
    `${delivery.representativeFirstName ?? ""} ${delivery.representativeLastName ?? ""}`.trim();
  return name.length > 0 ? name : "-";
}
